export default __webpack_public_path__ + "static/media/property_782.72e10047.png";